"use client";

import { useEffect, useRef } from "react";

import { analyticsManager } from "./analytics-manager";
import { type AnalyticsEvent } from "./analytics-events";

/**
 * Fires a view-style analytics event once per unique payload. Reusable across
 * any view surface (PDP, PLP, search, …) — the dedup is keyed on the serialized
 * event, so re-renders and soft navigations don't double-count. Call from a
 * client component; server templates use `<AnalyticsView>` instead.
 */
export function useTrackView(event: AnalyticsEvent): void {
	const firedKey = useRef<string | null>(null);
	const eventRef = useRef(event);
	eventRef.current = event;
	const key = JSON.stringify(event);

	useEffect(() => {
		if (firedKey.current === key) return;
		firedKey.current = key;
		analyticsManager.track(eventRef.current);
	}, [key]);
}
